/**
 * Ensures ID is a number.
 */
export const normalizeId = (id: string | number | undefined | null): number => {
  if (id === undefined || id === null) return 0;
  return Number(id);
};

/**
 * Checks if a document type ID is contained within a set of document IDs.
 */
export const isDocumentInSet = (
  docTypeId: number,
  idsSet: Set<number>
): boolean => {
  return idsSet.has(docTypeId);
};

/**
 * Gets a set of all document type IDs contained within the specified lists.
 */
export const getDocIdsFromLists = (
  listIds: number[],
  allLists: any[]
): Set<number> => {
  const idsSet = new Set<number>();
  listIds.forEach((listId) => {
    const list = allLists.find((l) => l.id === listId);
    if (list && Array.isArray(list.documents)) {
      list.documents.forEach((docId: number) => {
        idsSet.add(docId);
      });
    }
  });
  return idsSet;
};
